import { useMediaQuery, useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import MuiLink from '@mui/material/Link';
import { RycLogo } from '@onesource/icons';

export const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Box sx={{ height: { md: 67, xs: 50 } }} />

      <AppBar
        data-testid="main-header"
        position="fixed"
        color="default"
        sx={{
          boxShadow: 'none',
          height: { md: 67, xs: 50 },
          background: theme => theme.palette.common.white,
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <MuiLink href="https://restoreyourcore.com" sx={{ display: 'flex' }}>
            <RycLogo color={theme.palette.primary.light} width={isMobile ? 50 : 100} height={isMobile ? 31 : 44} />
          </MuiLink>
        </Container>
      </AppBar>
    </>
  );
};
